'use client';
import React, { useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

interface TextAreaProps {
  label: string;
  name?: string;
  className?: string;
  inputClassName?: string;
  rows?: number;
  disabled?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
  name,
  label,
  className,
  inputClassName,
  rows,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [field, meta, helpers] = name ? useField(name) : [{}, {}];
  const [focused, setFocused] = useState(false);
  const [labelWidth, setLabelWidth] = useState(0);

  const labelRef = useRef<HTMLLabelElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (labelRef.current) {
      setLabelWidth(labelRef.current.offsetWidth);
    }
  }, []);
  useEffect(() => {
    setFocused(field.value && true);
  }, [field.value]);

  const handleBlur = () => {
    if (inputRef.current && inputRef.current.value === '') {
      setFocused(false);
    } else {
      setFocused(true);
    }
  };

  return (
    <div
      className={`minthr-form-outline  ${label ? '' : 'hide-label'} ${meta.error && meta.touched ? 'error' : ''} ${
        className ? className : ''
      }`}
    >
      <div className="">
        <textarea
          {...field}
          ref={inputRef}
          onChange={(e) => helpers?.setValue(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={(e) => handleBlur()}
          className={`minthr-form-control ${inputClassName} ${focused ? 'active' : ''}`}
          name={name}
          rows={rows}
          disabled={disabled}
        ></textarea>
        <label ref={labelRef} className="minthr-form-label">
          {label}
        </label>
        <>
          {meta.touched && meta.error ? (
            <div className="minthr-form-message">
              <span className="field-validation-error">
                <span>{t(meta.error)}</span>
              </span>
            </div>
          ) : null}
        </>
        <div className={'minthr-form-notch'}>
          <div className="minthr-form-notch-leading"></div>
          <div
            className="minthr-form-notch-middle"
            style={{ minWidth: `${labelWidth + 25}px` }}
          ></div>
          <div className="minthr-form-notch-trailing"></div>
        </div>
      </div>
    </div>
  );
};

export default TextArea;
